import { NgModule } from '@angular/core';
import { RouterModule, Router, NavigationEnd, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'app',
                component: AppComponent,
                canActivate: [AppRouteGuard],
                canActivateChild: [AppRouteGuard],
                children: [
                    {
                        path: '',
                        children: [
                            {
                                path: 'notifications',
                                component: NotificationsComponent
                            },
                            {
                                path: '',
                                redirectTo: '/dashboard',
                                pathMatch: 'full'
                            }
                        ]
                    },
                    {
                        path: 'main',
                        loadChildren: 'app/main/main.module#MainModule',
                        data: { preload: true }
                    },
                    {
                        path: 'admin',
                        loadChildren: 'app/admin/admin.module#AdminModule',
                        data: { preload: true }
                    },
                    {
                        path: 'improvement-programs',
                        loadChildren: 'app/magic-numbers/magic-numbers.module#MagicNumbersModule',
                        data: { preload: true }
                    },
                    {
                        path: 'smart-scheduling',
                        loadChildren: 'app/smart-scheduling/smart-scheduling.module#SmartSchedulingModule',
                        data: { preload: true }
                    },
                    {
                        path: 'booking-lists',
                        loadChildren: 'app/booking-lists/booking-lists.module#BookingListsModule',
                        data: { preload: true }
                    },
                    {
                        path: 'patient-tracking-list',
                        loadChildren: 'app/patient-tracking-list/patient-tracking-list.module#PatientTrackingListModule',
                        data: { preload: true }
                    },
                    {
                        path: '**',
                        redirectTo: 'notifications'
                    }
                ]
            }
        ])
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
    constructor(private router: Router) {
        router.events.subscribe(event => {
            if (event instanceof RouteConfigLoadStart) {
                abp.ui.setBusy();
            }

            if (event instanceof RouteConfigLoadEnd) {
                abp.ui.clearBusy();
            }

            if (event instanceof NavigationEnd) {
                $('meta[property=og\\:url]').attr('content', window.location.href);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts